<template>
  <div class="login">
    <div class="login_page">
      <div class="logo_background">
        <img class="logo_img" :src="logo" />
      </div>
      <div class="login_content">
        <input
          class="login_input_enterprise_id"
          id="enterprise_id"
          type="text"
          :placeholder="enterpriseId"
        />
        <input
          class="login_input_user_id"
          id="user_id"
          type="text"
          :placeholder="Id"
        />
        <input
          class="login_input_password"
          id="login_password"
          type="password"
          :placeholder="password"
        />
        <input
          type="button"
          class="login_button"
          :value="login"
          @click="loginAction"
        />
      </div>
      <footer>
        <div class="privacy_policy_label label">
          <a
            class="aihone_link"
            href="https://www.aiphone.co.jp/privacy/ "
            target="_blank"
            >{{ privacyPolicylabel }}</a
          >
        </div>
        <p class="copy_right">
          Copyright &copy; Aiphone Co., Ltd. All rights reserved.
        </p>
        <p class="rev">{{ rev }}</p>
      </footer>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showMaintenanceModal">
      <maintenanceModalWindow :message="maintenanceMessage" @close="close">
      </maintenanceModalWindow>
    </div>
    <div class="unauthorized_modal_window" v-if="showUnauthorizedModal">
      <unauthorizedModalWindow @close="closeUnauthorizedModal">
      </unauthorizedModalWindow>
    </div>
    <div class="forbidden_modal_window" v-if="showForbiddenModal">
      <forbiddenModalWindow @close="closeForbiddenModal">
      </forbiddenModalWindow>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import unauthorizedModalWindow from '../modalWindow/unauthorizedModalWindow.vue'
import forbiddenModalWindow from '../modalWindow/forbiddenModalWindow.vue'
import maintenanceModalWindow from '../modalWindow/maintenanceModalWindow.vue'

export default {
  data() {
    return {
      logo: require('../../img/loginLogo.png'),
      enterpriseId: '企業ID',
      Id: 'ユーザID',
      password: 'Password',
      login: 'SIGN IN',
      rev: 'Ver.3.30',
      privacyPolicylabel: '個人情報保護方針',
      maintenanceMessage: '',
      completeWord: '',
      showCompleteModal: false,
      showMaintenanceModal: false,
      showloadingModal: false
    }
  },
  computed: {
    showUnauthorizedModal() {
      return this.$store.state.masters.unauthorizedFlag
    },
    showForbiddenModal() {
      return this.$store.state.masters.forbiddenFlag
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
    completeModalWindow,
    loadingModalWindow,
    unauthorizedModalWindow,
    forbiddenModalWindow,
    maintenanceModalWindow
  },
  methods: {
    async loginAction() {
      this.showloadingModal = true
      var companyId = document.getElementById('enterprise_id').value
      var userId = document.getElementById('user_id').value
      var password = document.getElementById('login_password').value
      if (companyId === '' || userId === '' || password === '') {
        let eventNumber = this.$store.state.error.errorCode.errorCode_110003
        let eventType = 1
        let reason = 'MSGCRC0001'
        this.completeWord =
          this.errorMsg.MSGCRC0001.name +
          this.errorMsg.MSGCRC0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        if (companyId === '') {
          reason += ' 企業Idが入力されていません。'
        }
        if (userId === '') {
          reason += ' ユーザIdが入力されていません。'
        }
        if (password === '') {
          reason += ' パスワードが入力されていません。'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch('masters/loginCareRings', {
          companyId,
          userId,
          password
        })
      } catch (error) {
        if (error.response && error.response.status === 410) {
          // 切り戻し時のAzureへのリダイレクト
          window.location.href =
            'https://carertiwvm01.japaneast.cloudapp.azure.com/Pages'
          return
        }
        if (error.response && error.response.status === 503) {
          this.showloadingModal = false
          // メンテナンス中
          this.showMaintenanceModal = true
          this.maintenanceMessage = error.response.data.header.message
          return
        }
        if (error.response && error.response.status === 423) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_110004
          this.showloadingModal = false
          // アカウントロック中
          this.showCompleteModal = true
          this.completeWord =
            this.errorMsg.MSGCRC0275.name +
            this.errorMsg.MSGCRC0275.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          return
        }
        let eventNumber = this.$store.state.error.errorCode.errorCode_110001
        let eventType = 1
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0001') {
            this.completeWord =
              this.errorMsg.MSGCRC0001.name +
              this.errorMsg.MSGCRC0001.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0002') {
            this.completeWord =
              this.errorMsg.MSGCRC0002.name +
              this.errorMsg.MSGCRC0002.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.completeWord =
              this.errorMsg.MSGCRC0096.name +
              this.errorMsg.MSGCRC0096.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0096'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0096.name +
            this.errorMsg.MSGCRC0096.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
        this.showloadingModal = false
        return
      }
      try {
        await this.$store.dispatch('masters/setMaster')
        this.$router.push('/dashboard')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_110002
        let eventType = 1
        let reason = 'MSGCRC0003'
        if (error.response) {
          this.completeWord =
            this.errorMsg.MSGCRC0003.name +
            this.errorMsg.MSGCRC0003.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        if (this.showUnauthorizedModal) {
        } else {
          this.showCompleteModal = true
        }
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showCompleteModal = false
      this.showMaintenanceModal = false
    },
    closeUnauthorizedModal(e) {
      this.$store.dispatch('masters/changeUnauthorizedFlag')
    },
    closeForbiddenModal(e) {
      this.$store.dispatch('masters/changeForbiddenFlag')
    }
  }
}
</script>

<style scoped>
.login {
  background-color: #f1f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/careRingsLogin/careRingsLogin.vue